/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
// Estonian
export default {
    'fabric.atlassianSwitcher.switchTo': 'Asenda tootega',
    'fabric.atlassianSwitcher.switchToTooltip': 'Asenda tootega…',
    'fabric.atlassianSwitcher.recent': 'Hiljutised',
    'fabric.atlassianSwitcher.more': 'Rohkem',
    'fabric.atlassianSwitcher.try': 'Proovi',
    'fabric.atlassianSwitcher.manageList': 'Halda loendit',
    'fabric.atlassianSwitcher.jiraProject': 'Jira projekt',
    'fabric.atlassianSwitcher.confluenceSpace': 'Confluence’i ruum',
    'fabric.atlassianSwitcher.people': 'Inimesed',
    'fabric.atlassianSwitcher.administration': 'Administreerimine',
    'fabric.atlassianSwitcher.discoverMore': 'Avasta veel',
    'fabric.atlassianSwitcher.errorHeading': 'Midagi läks valesti',
    'fabric.atlassianSwitcher.errorText': 'Hoiame neil vigadel silma peal, ent võid ka meiega ühendust võtta, kui värskendamine ei tee asju paremaks.',
    'fabric.atlassianSwitcher.errorImageAltText': 'Robot on katki ja mitu inimest tegelevad praegu selle parandamisega.',
    'fabric.atlassianSwitcher.expand': 'Laienda',
};
//# sourceMappingURL=et.js.map